import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./ui/tooltip";
import { Button } from "./ui/button";
import { ButtonProps } from "./ui/button";

export interface IconButtonProps extends ButtonProps {
  tooltip?: string;
}

export const IconButton = ({ children, tooltip, ...props }: IconButtonProps) => {
  if (tooltip) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button {...props} size="icon">
              {children}
            </Button>
          </TooltipTrigger>
          <TooltipContent side="top">{tooltip}</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return (
    <Button {...props} size="icon">
      {children}
    </Button>
  );
};
